import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusCardText], [campus-card-text], campus-card-text',
})
export class CardTextDirective {
  @HostBinding('class')
  defaultClasses = ['body-medium'];
}
